import { Microfrontend } from '@cian/mf-react';
import { IMicrofrontendManifest } from '@cian/mf-registry/shared';
import * as React from 'react';
import { useSelector } from 'react-redux';

import { useFiltersUpdatedEvent, useSaveSearchModal } from './hooks';
import { SaveSearchModalContainer } from '../SaveSearchModalContainer';
import { usePuidsSelector } from 'shared/hooks/usePuidsSelector';
import { selectIsAgent } from 'shared/selectors/user';
import { useApplicationContext } from 'shared/utils/applicationContext';

export const DesktopFiltersMicrofrontend: React.FC = () => {
  const { config } = useApplicationContext();

  const manifest = config.get<IMicrofrontendManifest | null>('desktopFiltersMicrofrontendManifest');

  useFiltersUpdatedEvent();

  const { open, onModalClose, onModalOpen, onSubscribed, subscribeToPush } = useSaveSearchModal();

  const userIsAgent = useSelector(selectIsAgent);

  const adfoxPuids = usePuidsSelector();

  return (
    <>
      {manifest && (
        <Microfrontend
          name={manifest.microfrontendName}
          image={manifest.imageVersion}
          runtime={manifest.runtimeName}
          instance={manifest.instanceId}
          parameters={{
            adfoxPuids,
            professionalSearchAvailable: userIsAgent,
          }}
        />
      )}
      <SaveSearchModalContainer
        isOpen={open}
        onSubscribed={onSubscribed}
        onPushSubscribed={subscribeToPush}
        onOpen={onModalOpen}
        onClose={onModalClose}
      />
    </>
  );
};
